var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecorativeLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 6,
    viewBox: "0 0 29 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 6,
    rx: 3,
    fill: "#D1EF54"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 22,
    height: 6,
    rx: 3,
    fill: "#06CEA8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#DEFDBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeLine2);
export default __webpack_public_path__ + "static/media/decorative-line-2.d3deaa5c569846ecb3c4923f6954cdde.svg";
export { ForwardRef as ReactComponent };